import '../../styles/globals.css'
import { useState } from 'react';
import api from '../../service/api';

function Leads(){
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        phoneNumberWithoutMask: '',
        plan:''
      });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

      const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'phoneNumber') {
          const phone = formatPhoneNumber(value);
          setFormData((prevData) => ({
            ...prevData,
            phoneNumber: phone,
            phoneNumberWithoutMask: phone.replace(/\D/g, ''),
          }));
        } else {
           setFormData({
          ...formData,
          [name]: value,
        });
        }
      };

      const formatPhoneNumber = (e) => {
        const input = e.replace(/\D/g, '');
        let formattedInput = '';
        
        if (input.length > 0) {
          formattedInput = `(${input.substring(0, 2)}`;
        }
        if (input.length > 2) {
          formattedInput += `) ${input.substring(2, 7)}`;
        }
        if (input.length > 7) {
          formattedInput += `-${input.substring(7, 11)}`;
        }
        return formattedInput;
      }

      const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError(null);
        setSuccess(false);
        try {
            // Dados que serão enviados (sem a máscara)
            const dadosParaEnviar = {
              name: formData.name,
              email: formData.email,
              phoneNumber: formData.phoneNumberWithoutMask,
              typePlan: formData.plan,
              ClientId: process.env.REACT_APP_CLIENT_ID
            };
            
            // Configuração do Axios (ajuste a URL para seu endpoint)
            const response = await api.post('/v1/leads', dadosParaEnviar);
      
            console.log('Resposta da API:', response.data);
            setSuccess(true);

            // Chama a função definida no snippet do Google
          if (typeof window.gtag_report_conversion === "function") {
              window.gtag_report_conversion("https://corretoradnasaude.com.br/");
          }
            
            // Limpa o formulário após o sucesso (opcional)
            setFormData({
              name: '',
              email: '',
              phoneNumber: '',
              phoneNumberWithoutMask: '',
              plan:''
            });

          
          } catch (err) {
            console.error('Erro ao enviar dados:', err);
            setError(err.response?.data?.message || 'Erro ao enviar formulário');
          } finally {
            setLoading(false);
          }
      };
    
    return (
        <section className="cta" id="form">
        <div className="container">
            <h2>Pronto para ter seu plano Hapvida?</h2>
            <p>Solicite uma cotação gratuita e sem compromisso. Nossos consultores entrarão em contato para encontrar o melhor plano para suas necessidades.</p>
            
            <form onSubmit={handleSubmit} style={{maxWidth: '600px', margin: '0 auto', background: 'white', padding: '30px', borderRadius: '10px', textAlign: 'left'}}>
                <div style={{marginBottom: '20px'}}>
                    <label style={{display: 'block', marginBottom: '5px', color: 'var(--dark)'}}>Nome Completo</label>
                    <input 
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder='Nome'
                        style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '5px'}}
                    />
                </div>
                <div style={{marginBottom: '20px'}}>
                    <label style={{display: 'block', marginBottom: '5px', color: 'var(--dark)'}}>E-mail</label>
                    <input 
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder='E-mail'
                        style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '5px'}}
                    />
                </div>
                <div style={{marginBottom: '20px'}}>
                    <label style={{display: 'block', marginBottom: '5px', color: 'var(--dark)'}}>Telefone</label>
                    <input 
                        type="tel"
                        name="phoneNumber"
                        placeholder="(__) _____-____"
                        maxLength="15"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '5px'}}
                    />
                </div>
                <div style={{marginBottom: '20px'}}>
                    <label style={{display: 'block', marginBottom: '5px', color: 'var(--dark)'}}>Plano de Interesse</label>
                    <select id="plan"
                        name="plan"
                        value={formData.plan} 
                        onChange={handleChange}
                        style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '5px'}}
                    >
                        <option value="">Selecione um plano</option>
                        <option value="basico">Plano Infantil</option>
                        <option value="basico">Plano Básico</option>
                        <option value="familiar">Plano Familiar</option>
                        {/*<option value="premium">Plano Premium</option>*/}
                        <option value="empresarial">Plano Empresarial</option>
                    </select>
                </div>
                <button 
                  type="submit" 
                  className="btn" 
                  style={{width: '100%', opacity: loading ? 0.7 : 1}} 
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      Enviando...
                      <span className="loader" />
                    </>
                  ) : 'Solicitar Cotação'}
                </button>
                {success && (
                  <p style={{ color: 'green', marginTop: '15px', textAlign: 'center' }}>
                    ✅ Solicitação enviada com sucesso! Entraremos em contato em breve.
                  </p>
                )}

                {error && (
                  <p style={{ color: 'red', marginTop: '15px', textAlign: 'center' }}>
                    ❌ {error}
                  </p>
                )}

            </form>
        </div>
    </section>
    );
}

export default Leads;